export interface ITaskSettings {
  id: string;
  defaultComputingUnits: number;
  consumptionMode: ConsumptionModes;
}

export enum ConsumptionModes {
  FILE_SIZE,
  TIME
}
